import { useEffect, useState } from "react";
import firebase from "@services/firestore";
import { isCreativeOrAdBuyID } from "../util/idTypeChecker.js";
import { CreativeStore } from "../store/CreativeStore";

/* 
    if the buildId is a ad line id or creative id, we'll need to find the buildId to load
    here we'll need to query for a scrub session with the ad/creative id and access the 
    parent collection for the buildId
*/
export default function useStudioBuildID(id) {
  const [buildID, setBuildID] = useState(null);
  const setErrorLoadingCreative = CreativeStore(
    (state) => state.setErrorLoadingCreative
  );

  useEffect(() => {
    const fetchBuildID = async () => {
      if (isCreativeOrAdBuyID(id)) {
        try {
          // For new creatives, adBuyId is stored as a number instead of a string.
          // We query by number first, since that's the format used going forward.
          const numQuery = firebase
            .firestore()
            .collectionGroup("scrubSessions")
            .where("creativeID", "==", Number(id))
            .limit(1);

          const numResult = await numQuery.get();

          if (!numResult.empty) {
            // Found with number query
            setBuildID(numResult.docs[0].ref.parent.parent.id);
            setErrorLoadingCreative(false);
            return;
          }

          // Try with string query
          const stringQuery = firebase
            .firestore()
            .collectionGroup("scrubSessions")
            .where("creativeID", "==", String(id))
            .limit(1);

          const stringResult = await stringQuery.get();

          if (!stringResult.empty) {
            // Found with string query
            setBuildID(stringResult.docs[0].ref.parent.parent.id);
            setErrorLoadingCreative(false);
          } else {
            // No results from either query
            setErrorLoadingCreative(true);
          }
        } catch (error) {
          console.error("Error fetching buildID:", error);
          setErrorLoadingCreative(true);
        }
      } else {
        setBuildID(id);
        setErrorLoadingCreative(false);
      }
    };

    fetchBuildID();
  }, [id]);
  return buildID;
}
